import './polyfills';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { init as initApm } from '@elastic/apm-rum';
import { App } from './App';
import './index.scss';
import { configuration } from './configuration';
import { getTenant } from './tenant-support/get-tenant';

window.addEventListener('vite:preloadError', () => {
  const reloadKey = 'vite-preload-reloaded';
  if (sessionStorage.getItem(reloadKey)) {
    return;
  }
  sessionStorage.setItem(reloadKey, '1');
  window.location.reload();
});

const apm = initApm({
  active: configuration.apmEnabled,
  serverUrl: configuration.apmServerUrl,
  serviceName: 'jobcenter-desktop-frontend',
  serviceVersion: configuration.imageTag,
  environment: configuration.apmEnvironment,
  distributedTracing: true,
  distributedTracingOrigins: [configuration.bffBase],
  disableInstrumentations: ['eventtarget'],
  ignoreTransactions: [/gettenantconfiguration/i, /getallfeaturetoggles/i, /getsystemconfiguration/i, /getcrmhosturl/i],
});
const tenant = getTenant();
apm.addLabels({ tenant: tenant.name });

const screenResolution = `${window.screen.width}:${window.screen.height}`;

apm.addLabels({ resolution: screenResolution });

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

if (process.env.NODE_ENV === 'development') {
  // Vite HMR
  if (import.meta.hot) {
    import.meta.hot.accept('./App', () => {
      root.render(<App />);
    });
  }
  // Webpack HMR
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  else if (typeof module !== 'undefined' && (module as any).hot) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (module as any).hot.accept('./App', () => {
      root.render(<App />);
    });
  }
}
